// Company logo for the report pages. The logo is a public file of the company's storage;
// without one, the company's initial stands in, so the header never has a broken image.
// Plain <img>: the URL is a remote public file of any size, and next/image would need a
// per-host allowlist for every company.
export function ReportLogo({
  name,
  url,
}: {
  name: string;
  url: string | null;
}) {
  if (url) {
    return (
      // eslint-disable-next-line @next/next/no-img-element -- remote public logo, see comment above
      <img
        src={url}
        alt={`Logo de ${name}`}
        className="h-[80px] w-[80px] shrink-0 rounded-md object-contain"
      />
    );
  }
  return (
    <span
      aria-hidden
      className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-[var(--rp-accent-soft)] text-base font-semibold text-[var(--rp-accent)]"
    >
      {name.charAt(0).toUpperCase()}
    </span>
  );
}
